import type {userState, companyGroupAction} from './types'

const INITIAL_STATE: userState = {
  loading: false,
  isSuperAdmin: false,
  isUser: false,
  data: undefined,
  myCompany: undefined,
}

export const userReducer = (
  prev: userState = INITIAL_STATE,
  action: companyGroupAction
): userState => {
  switch (action.type) {
    case 'USER/SET_DATA':
      return {
        ...prev,
        data: action.payload,
      }
    case 'USER/SET_LOADING':
      return {
        ...prev,
        loading: action.payload,
      }
    case 'USER/SET_IS_SUPER_ADMIN':
      return {
        ...prev,
        isSuperAdmin: action.payload,
      }
    case 'USER/SET_IS_USER':
      return {
        ...prev,
        isUser: action.payload,
      }
    case 'USER/SET_USER_COMPANY':
      return {
        ...prev,
        myCompany: action.payload,
      }
    case 'USER/GET_DATA':
      return {
        ...prev,
        loading: false,
      }

    default:
      return prev
  }
}
